import {defineCustomElement} from 'extensions/utils';
import {LitElement, html, nothing} from 'lit';
import {MutationObserverMixin} from './mutation-observer-mixin';
import stylesheet from './x-toggle-details.component.scss?as=stylesheet';

// eslint-disable-next-line new-cap
export class ToggleDetails extends MutationObserverMixin(LitElement) {
	static get styles () {
		return [stylesheet];
	}

	static get properties () {
		return {
			_limit: {
				attribute: 'limit',
				type: Number
			},
			labelClosed: {
				attribute: 'label-closed',
				type: String
			},
			labelOpened: {
				attribute: 'label-opened',
				type: String
			},
			open: {
				type: Boolean
			},
			selector: {
				type: String
			}
		};
	}

	mutationObserverOptions = {
		attribute: false,
		childList: true,
		subtree: false
	};

	get limit () {
		return this.toggleableChildren?.length - this._limit <= 3
			? this._limit + 3
			: this._limit;
	}

	set limit (value) {
		this._limit = value;
	}

	constructor () {
		super();

		this._limit = 10;
		this.labelClosed = 'Show More';
		this.labelOpened = 'Show Less';
		this.open = false;
		this.selector = '';
	}

	get toggleableChildren () {
		return this.querySelectorAll(this.selector || ':scope > *');
	}

	setHiddenState () {
		for (let i = 0; i < this.toggleableChildren.length; i++) {
			const child = this.toggleableChildren[i];


			child.hidden = !this.open && i >= this.limit;
		}
	}

	toggleOpen () {
		this.open = !this.open;

		if (this.open) {
			window.requestAnimationFrame(() => {
				this.renderRoot?.querySelector('#content')?.scrollIntoView({
					behavior: 'smooth'
				});
			});
		}
	}

	handleMutation () {
		this.setHiddenState();
		this.requestUpdate();
	}

	updated (changedProperties) {
		if (changedProperties.has('limit') || changedProperties.has('open')) {
			this.setHiddenState();
		}
	}

	renderButton () {
		if (this.limit >= this.toggleableChildren?.length) {
			return nothing;
		}

		return html`
			<button class="toggle-button" @click="${this.toggleOpen}">
				<span class="label">${this.open ? this.labelOpened : this.labelClosed}</span>
			</button>
		`;
	}

	render () {
		return html`
			<div class="content" id="content">
				<slot></slot>
			</div>

			${this.renderButton()}
		`;
	}
};

defineCustomElement('x-toggle-details', ToggleDetails);
